import axios, { AxiosRequestConfig } from 'axios';
import firebase from 'firebase/compat/app';

const getToken = () => firebase.auth().currentUser?.getIdToken();

const fetcher = async (url: string, options: AxiosRequestConfig = {}) => {
  const token = await getToken();

  const method = options.method || 'GET';
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };

  return axios({
    url,
    method,
    headers,
    data: options.data,
    params: options.params,
  }).then((response) => response.data);
};
export default fetcher;
